// Importar dependencias
import ApiClient from "./ApiClient";

const subscriptionUrl = "subscription/";

// Cancela una suscripción
async function getPortal() {
  // Intentamos ejecutar la petición
  try {
    const response = await ApiClient.post(subscriptionUrl + "portal");
    return response.data;
  } catch (err) {
    throw new Error(err.response.data.message);
  }
}

export default {
  getPortal
};
